import React, { useEffect } from 'react'
import { useApi } from '../../../hooks/useApi'
import { getPickingRouteProducts } from '../api'
import { ProductValidation } from '../ProductValidationModal/ProductValidation'
import { State } from '../../_EOS/State'
import { Typography, Grid, List } from '@mui/material'
import { ListItemIcon } from '../../ListItemIcon/ListItemIcon'
import { ConfirmAction } from '../../ConfirmAction'
import { Status } from '../../../hooks/useFetchState'

interface CloseValidationConfirmationModalProps {
  isPickingRouteGroupedValidation: boolean
  orderCancellationRequest: boolean
  handleClosePickingRouteValidate: () => void
  handleCloseConfirmation: () => void
  isLoadingConfirm: boolean
  pickingRouteId: number
}

export const CloseValidationConfirmationModal: React.FC<CloseValidationConfirmationModalProps> =
  ({
    isPickingRouteGroupedValidation,
    pickingRouteId,
    handleCloseConfirmation,
    handleClosePickingRouteValidate,
    orderCancellationRequest,
    isLoadingConfirm
  }) => {
    const { callApi, state } = useApi<ProductValidation[]>()

    const requestPickingRouteProducts = () => {
      callApi(getPickingRouteProducts(pickingRouteId))
    }

    useEffect(() => {
      if (!isPickingRouteGroupedValidation) {
        requestPickingRouteProducts()
      }
    }, [])

    if (
      isPickingRouteGroupedValidation ||
      (!isPickingRouteGroupedValidation &&
        (state.data || []).filter((el) => !el.validated).length === 0 &&
        Status.Loading !== state.status)
    ) {
      return (
        <ConfirmAction
          handleCloseModal={handleCloseConfirmation}
          handleSubmitAction={() => {
            handleClosePickingRouteValidate()
            handleCloseConfirmation()
          }}
          confirmTitle={
            (orderCancellationRequest &&
              'Recuerde devolver físicamente los productos a sus respectivas posiciones originales.') ||
            `¿Esta seguro que desea cerrar la validación de ruta?`
          }
          confirmText={`Confirmar`}
          negateText={`Cancelar`}
          isLoading={isLoadingConfirm}
        />
      )
    }

    return (
      <State state={state} loadingMessage='Cargando'>
        <Grid container direction='column' spacing={2} alignItems='center'>
          <Grid item xs={12}>
            <Typography variant='h6'>Faltan SKUs por validar</Typography>
          </Grid>

          <Grid item xs={12}>
            {state.data
              ?.filter((sku) => !sku.validated)
              .map((item) => (
                <Grid container direction='row' spacing={2}>
                  <Grid item xs={6}>
                    <Typography>{item.sku}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>{item.productName}</Typography>
                  </Grid>
                </Grid>
              ))}
          </Grid>
          <Grid item xs={12}>
            <List>
              <ListItemIcon
                primary={''}
                secondary={'Debe validar todos los SKUs de la ruta'}
                icon='info'
              />
            </List>
          </Grid>
        </Grid>{' '}
      </State>
    )
  }
